export default "__VITE_ASSET__UGN5UWxs__"